<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
        <li><router-link to="/admin">Dashboard</router-link></li>
        <li class="active">Print Coupons Delete Archive List</li>
        
      </ol>
        <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          
       <div class="panel-body1 locationform">
           <div class="row ">
              <div class="col-md-5">
                    <div class="form-group">
                      <label>Product List</label>
                      <Select2SearchWithTokenPrefetch
                        :remoteControl="'kspgAPI/Product/search'"
                        :selectedOptionArray ="roleAlready"
                        @selectedData="ProductSelect"
                      ></Select2SearchWithTokenPrefetch>
                      <span v-if="errors.has('ProductSearch')">
                          {{ errors.first('ProductSearch') }}
                        </span>
                    </div>
                  </div>
                  <div class="col-md-2">
                      <div class="form-group">
                        <br>
                        <button  class="btn btn-primary submitbtn btn-raised pull-right" @click="$router.push('printCoupons')">Coupon List</button>
                      </div>
                  </div>
                  <div class="col-md-2">
                      <div class="form-group">
                        <br>
                        <button  class="btn btn-danger submitbtn btn-raised pull-right" @click="DeleteCoupons">Delete Coupons</button>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="form-group">
                        <br>
                        <button  class="btn btn-primary submitbtn btn-raised pull-right" @click="UnDeleteCoupons">Un Delete Coupons</button>
                      </div>
                  </div>
            <div class="col-md-12">

<button type="button" class="btn btn-default">Total Coupons <span class="badge"> {{TotalCoupon}}</span></button>

<button type="button" class="btn btn-default">Total Coupon Printed <span class="badge"> {{PrintedCoupon}}</span></button>



        </div>
               
           <div class="col-md-12">
             <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <!-- <td>Serial Number</td> -->
                    <td>Product Name</td>
                    <th>Points</th>
                    <!-- <th>Status</th> -->
                    <th>QR Code</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">
                      <!-- <router-link
                        :to="{
                          name: 'editReborer',
                          params: { partner_id: item.id },
                        }"
                        ></router-link
                      > -->
                      {{ item.coupon }}
                    </td>
                    <!-- <td>{{ item.serial_number }}</td> -->
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.points }}</td>
                    <!-- <td>{{ item.PrintStatus }}</td> -->
                    <td><vue-qrcode :value='item.coupon'
                      :quality=0.92
                     :errorCorrectionLevel="'L'"  :color="{ dark: '#000000ff', light: '#ffffffff' }" :type='"image/png"' /></td>
                    <td>{{ item.created_date | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
                <!--end table-->
                 <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
           </div>
           </div>
       </div>
       
      </div>
    </div>
    
  </div>
</template>
<script>


import VueQrcode from 'vue-qrcode'
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment'
import Select2SearchWithTokenPrefetch from '../components/Select2SearchWithTokenPrefetch';
export default {
  name: 'PrintCouponsDeleteArchive',
  data() {
    return {
      roleAlready:{},
      ErrorMessage:'',
      SuccessMessage:'',
      coupon_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      PrintedCoupon:0,
      TotalCoupon:0,
      product_t_id:'',
    };
  },
  components: {
    Paginate,
   VueQrcode,
   Select2SearchWithTokenPrefetch
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
      serialize(obj) {
      var str = [];
      for(var p in obj){
          if (obj.hasOwnProperty(p)) {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
      }
      return str.join("&");
  },
  UnDeleteCoupons(){
    if(!this.product_t_id){
        alert("Please Select Product To process Un-Delete");
        return false;
      }
      if(!confirm('Going to Undelete All Non Printed Coupons,Are you sure?')){
        return true;
      }
    const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      params['delete'] = "unDelete";
    commonServices.put('kspgAPI/Coupon/',params)
      .then((responce) => {
            this.SuccessMessage = responce.data.message;
            if (responce.data.status) {
              //
              this.getAllCoupons(0);  
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
  },
    DeleteCoupons(){
      if(!this.product_t_id){
        alert("Please Select Product To process Final Delete");
        return false;
      }
      if(!confirm('Going to delete All Non Printed Coupons Permanently,Are you sure?')){
        return true;
      }
       const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      params['delete'] = "DeleteFinal";
       let loader = this.$loading.show();
      commonServices
        .delete('kspgAPI/Coupon/', this.serialize(params))
        .then((response) => {
          if(response.data.status){
            this.getAllCoupons(0);  
            this.SuccessMessage = response.data.message;
            setTimeout(() => (this.SuccessMessage = false), 5000);
          }
          this.getAllCoupons(1);
        })
        .catch((e) => {
          this.ErrorMessage = e.response.data.message;
            setTimeout(() => (this.ErrorMessage = false), 5000);
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
          this.getAllCoupons(1);
        });
        setTimeout(() => {loader.hide()}, 1000)
    },
   
     ProductSelect(val) {
      this.product_t_id = val;
        this.getAllCoupons(0);  
    },
     getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
        if(this.product_t_id)
        {
          params['product_t_id'] = this.product_t_id
        }
        params['ViewName'] = 'Deleted';
      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/DownloadCoupons/couponList', params)
        .then((response) => {
          const {
            coupon_data,
            totalItems,
            currentPage,
            TotalPage,
            PrintedCoupon,
            TotalCoupon
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.PrintedCoupon =   PrintedCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 2000)
    },
  },
  created() {this.getAllCoupons(1);},
   mounted() {
    // this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
